export default "__VITE_ASSET__e04968ab__"